<script setup lang="ts">
import { useReferencesStore } from "@/store/references";
import type { ISolarPowerPlant } from "src/components/homePage/legal/InteractiveMap.vue";
import { useDefaultStore } from "@/store";

const router = useRouter();
const refStore = useReferencesStore();
const store = useDefaultStore();

function showCard(n: number) {
	store.activeCardRegular = store.activeCardRegular == n ? -1 : n;
}

function handleCardClick(event: { stopPropagation: () => void }) {
	event.stopPropagation();
}

const filteredReferences = computed(() => {
	return (
		refStore.referencesList?.filter(
			(ref: ISolarPowerPlant) => ref.blt_id === 2,
		) || []
	);
});

async function toReference(ref: ISolarPowerPlant) {
	await (ref.path == "blog"
		? router.push({
				name: "PostPage",
				params: { slug: ref.slug },
			})
		: router.push({
				name: "RegularReference",
				params: { slug: ref.slug },
			}));
}
</script>

<template lang="pug">
.interactiv-map-wrapper
	.view
		.map
			img(src="@/assets/image/interactiveMap/map.png", alt="map", loading="lazy")
			template(v-for="(ref, index) in filteredReferences", :key="index")
				.pin(
					:class="['pin', store.activeCardRegular == ref.id ? 'pin-active' : '', 'pin' + ref.id]",
					@click.stop="showCard(ref.id)"
				)
					img.pin-item(
						src="@/assets/image/interactiveMap/pin.png",
						alt="pin",
						loading="lazy"
					)
					.hover-card(
						:class="[store.activeCardRegular == ref.id ? 'hover-card-active' : '', 'hover-card' + ref.id]",
						@click.stop="handleCardClick($event)"
					)
						.title
							| {{ ref.titleTop }}
							br
							| {{ ref.titleBottom }}
							.close(@click.stop="showCard(ref.id)") &#10005;
						.image
							img.thumb(
								:class="[ref.thumb.endsWith('thumb-logo.png') ? 'no-thumb' : '']",
								:src="ref.thumb",
								alt="thumbnail",
								loading="lazy"
							)
						.text
							| {{ ref.description }}
						.text.see-more-wrapper
							.see-more(@click="toReference(ref)") {{ $t("app.seeMore") }}
</template>

<style lang="scss" scoped>
.interactiv-map-wrapper {
	display: flex;
	justify-content: center;

	.view {
		.map {
			position: relative;

			img {
				width: 100%;
			}

			.pin {
				position: absolute;
				cursor: pointer;

				.hover-card {
					display: none;
					flex-direction: column;
					position: absolute;
					justify-content: center;
					width: 300px;
					z-index: 1;
					opacity: 0;

					&.hover-card-active {
						display: flex;
						opacity: 1;
						animation: fade-in-out 1s ease-in-out forwards;
						.pin-item {
							filter: brightness(0) invert(1);
						}
					}

					.title {
						padding: 24px;
						background: $app-dark-color;
						color: $text-color-lighter;
						width: 100%;
						display: grid;
						place-items: center;
						border-radius: 10px 10px 0 0;
						text-transform: uppercase;
						font-family: Pelinka, sans-serif;
						font-size: 16px;
						line-height: 20px;
						font-weight: 700;
						text-align: center;
						position: relative;

						.close {
							color: $white;
							position: absolute;
							top: 8px;
							right: 8px;
						}
					}

					.image {
						text-align: center;
						padding: 10px;
						background-color: rgb(255, 255, 255);
						display: flex;
						justify-content: center;
						.thumb {
							height: 100px;
							border-radius: 50%;
							width: fit-content;
							max-width: 100%;
							aspect-ratio: 1 / 1;
							object-fit: cover;

							&.no-thumb {
								object-fit: contain;
							}
						}
					}

					.text {
						@include ellipsis;

						-webkit-line-clamp: 7;
						padding: 0 24px;
						background-color: $text-color-lighter;
						font-family: "Galano Grotesque Alt", sans-serif;
						font-size: 14px;
						line-height: 18px;
						font-weight: 300;
						text-align: justify;
						border-radius: 0;
						max-height: calc(7 * 18px);
						overflow: hidden;

						&.see-more-wrapper {
							padding-top: 0;
							display: flex;
							align-items: center;
							height: 60px;
							border-radius: 0 0 10px 10px;
						}

						.see-more {
							cursor: pointer;
							font-weight: 700;
							color: $app-accent-color1;
							text-transform: uppercase;

							&:hover {
								color: $app-accent-color1-lighter;
							}
						}
					}
				}

				.pin-item {
					width: 30px;
					height: 25px;
					cursor: pointer;
				}

				&.pin {
					display: none;
				}
				&.pin34 {
					left: 19%;
					top: 6%;
					display: block;
				}
				&.pin35 {
					left: 25%;
					top: 19%;
					display: block;
				}
				&.pin36 {
					left: 60%;
					top: 42%;
					display: block;
				}
				&.pin37 {
					left: 14%;
					top: 36%;
					display: block;
				}
				&.pin38 {
					left: 20%;
					top: 49%;
					display: block;
				}
				&.pin39 {
					left: 45%;
					top: 26%;
					display: block;
				}
				&.pin40 {
					left: 29%;
					top: 57%;
					display: block;
				}
				&.pin41 {
					left: 42%;
					top: 34%;
					display: block;
				}
				&.pin42 {
					left: 52%;
					top: 53%;
					display: block;
				}
				&.pin43 {
					left: 79%;
					top: 34%;
					display: block;
				}
				&.pin44 {
					left: 44%;
					top: 36%;
					display: block;
				}
				&.pin45 {
					left: 40%;
					top: 32%;
					display: block;
				}
				&.pin46 {
					left: 38%;
					top: 32%;
					display: block;
				}
				&.pin47 {
					left: 35%;
					top: 34%;
					display: block;
				}
				&.pin54 {
					left: 43%;
					top: 26%;
					display: block;
				}
				&.pin55 {
					left: 43%;
					top: 48%;
					display: block;
				}
				&.pin56 {
					left: 42%;
					top: 30%;
					display: block;
				}
				&.pin57 {
					left: 56%;
					top: 34%;
					display: block;
				}
				&.pin58 {
					left: 17%;
					top: 31%;
					display: block;
				}
				&.pin59 {
					left: 50%;
					top: 48%;
					display: block;
				}
				&.pin60 {
					left: 47%;
					top: 32%;
					display: block;
				}

				.hover-card34 {
					left: -42px;
					bottom: -392px;
				}
				.hover-card35 {
					left: -61px;
					bottom: -392px;
				}
				.hover-card36 {
					left: -182px;
					bottom: 40px;
				}
				.hover-card37 {
					left: -23px;
					bottom: 40px;
				}
				.hover-card38 {
					left: -47px;
					bottom: 40px;
				}
				.hover-card39 {
					left: -128px;
					top: 26px;
				}
				.hover-card40 {
					left: -77px;
					top: -402px;
				}
				.hover-card41 {
					left: -120px;
					bottom: 40px;
				}
				.hover-card42 {
					left: -157px;
					bottom: 40px;
				}
				.hover-card43 {
					left: -246px;
					bottom: 40px;
				}
				.hover-card44 {
					left: -129px;
					bottom: 40px;
				}
				.hover-card45 {
					left: -120px;
					bottom: 40px;
				}
				.hover-card46 {
					left: -120px;
					bottom: 40px;
				}
				.hover-card47 {
					left: -97px;
					bottom: 40px;
				}
				.hover-card54 {
					left: -128px;
					top: 26px;
				}
				.hover-card56 {
					left: -120px;
					bottom: 40px;
				}
				.hover-card55 {
					left: -125px;
					bottom: 39px;
				}
				.hover-card57 {
					left: -168px;
					bottom: 39px;
				}
				.hover-card58 {
					left: -23px;
					bottom: 40px;
				}
				.hover-card59 {
					left: -149px;
					bottom: 39px;
				}
				.hover-card60 {
					left: -139px;
					bottom: 39px;
				}

				&.pin-active {
					.hover-card {
						display: flex;
					}
					.pin-item {
						filter: brightness(0) invert(1);
					}
				}
			}
		}
	}
}

@media screen and (width >= 760px) {
	.interactiv-map-wrapper {
		.view {
			.map {
				.pin {
					.hover-card {
						width: 393px;

						.text {
							font-size: 20px;
							line-height: 27px;
							max-height: calc(7 * 27px);
						}

						.title {
							font-size: 22px;
							line-height: 25.3px;

							.close {
								display: none;
							}
						}

						.image {
							.thumb {
								height: 126px;
							}
						}
					}
					.pin-item {
						width: unset;
						height: unset;
					}
					.hover-card34 {
						left: 67px;
						bottom: -427px;
						top: unset;
					}
					.hover-card35 {
						left: -3px;
						bottom: -489px;
						top: unset;
					}
					.hover-card36 {
						left: -333px;
						bottom: 62px;
					}
					.hover-card37 {
						left: 2px;
						bottom: 60px;
					}
					.hover-card38 {
						left: 2px;
						bottom: 62px;
					}
					.hover-card39 {
						left: 0;
						top: 50px;
					}
					.hover-card40 {
						left: -1px;
						top: -502px;
					}
					.hover-card41 {
						left: -305px;
						bottom: 65px;
					}
					.hover-card42 {
						left: -336px;
						bottom: 65px;
					}
					.hover-card43 {
						left: -336px;
						bottom: 59px;
					}
					.hover-card44 {
						left: 1px;
						bottom: 59px;
					}
					.hover-card45 {
						left: 6px;
						bottom: -487px;
					}
					.hover-card46 {
						left: 2px;
						bottom: -486px;
					}
					.hover-card47 {
						left: -6px;
						top: 50px;
						bottom: unset;
					}
					.hover-card54 {
						left: -56px;
						top: 43px;
					}
					.hover-card55 {
						left: 0;
						top: -394px;
						bottom: unset;
					}
					.hover-card56 {
						left: -302px;
						top: 49px;
						bottom: unset;
					}
					.hover-card57 {
						left: -336px;
						top: -448px;
						bottom: unset;
					}
					.hover-car58 {
						left: -2px;
						bottom: -298px;
					}
					.hover-card59 {
						left: -337px;
						bottom: 63px;
					}
					.hover-card60 {
						left: -319px;
						bottom: -298px;
					}
				}
			}
		}
	}
}

@media screen and (width >= 1660px) {
	.interactiv-map-wrapper {
		.view {
			.map {
				.pin {
					&:hover {
						.hover-card {
							display: none;
						}
					}
					/* stylelint-disable-next-line no-descending-specificity */
					.hover-card {
						width: 393px;
						opacity: 0;

						.text {
							border-radius: 0;
						}

						&.hover-card-active {
							display: flex;
							opacity: 1;
							animation: fade-in-out 1s ease-in-out forwards;
							.pin-item {
								filter: brightness(0) invert(1);
							}
						}
					}
					.hover-card34 {
						left: 424px;
						bottom: -527px;
						top: unset;
					}
					.hover-card35 {
						left: 385px;
						bottom: -423px;
						top: unset;
					}
					.hover-card36 {
						left: 161px;
						bottom: -204px;
						top: unset;
					}
					.hover-card37 {
						left: 456px;
						bottom: -261px;
						top: unset;
					}
					.hover-card38 {
						left: 419px;
						bottom: -139px;
						top: unset;
					}
					.hover-card39 {
						left: 15.4vw;
						top: -85px;
						bottom: unset;
					}
					.hover-card40 {
						left: 359px;
						top: -368px;
						bottom: unset;
					}
					.hover-card41 {
						left: 17vw;
						top: -312%;
						bottom: unset;
					}
					.hover-card42 {
						left: 13vw;
						top: -598%;
						bottom: unset;
					}
					.hover-card43 {
						left: 40px;
						bottom: -281px;
						top: unset;
					}
					.hover-card44 {
						left: 264px;
						bottom: -267px;
						top: unset;
					}
					.hover-card45 {
						left: 291px;
						bottom: -302px;
						top: unset;
					}
					.hover-card46 {
						left: 304px;
						bottom: -302px;
						top: unset;
					}
					.hover-card47 {
						left: 19vw;
						top: -165px;
						bottom: unset;
					}
					.hover-card54 {
						left: 272px;
						top: -82px;
						bottom: unset;
					}
					.hover-card55 {
						left: 16.3vw;
						top: -291px;
						bottom: unset;
					}
					.hover-card56 {
						left: 16.3vw;
						top: -114px;
						bottom: unset;
					}
					.hover-card57 {
						left: 11.3vw;
						top: -166px;
						bottom: unset;
					}
					.hover-card58 {
						left: 439px;
						bottom: -121px;
						top: unset;
					}
					.hover-card59 {
						left: 227px;
						bottom: 32px;
						top: unset;
					}
					.hover-card60 {
						left: 246px;
						bottom: -113px;
						top: unset;
					}
				}
			}
		}
	}
}

@media screen and (width >= 1900px) {
	.interactiv-map-wrapper {
		.view {
			.map {
				.pin {
					.hover-card34 {
						left: 461px;
						bottom: -535px;
						top: unset;
					}
					.hover-card35 {
						left: 423px;
						bottom: -417px;
						top: unset;
					}
					.hover-card36 {
						left: 198px;
						bottom: -209px;
						top: unset;
					}
					.hover-car37 {
						left: 493px;
						bottom: -263px;
						top: unset;
					}
					.hover-car38 {
						left: 455px;
						bottom: -146px;
						top: unset;
					}
					.hover-card39 {
						left: 294px;
						top: -85px;
						bottom: unset;
					}
					.hover-card40 {
						left: 397px;
						top: -365px;
						bottom: unset;
					}
					.hover-card41 {
						left: 540%;
						top: -288%;
						bottom: unset;
					}
					.hover-card42 {
						left: 431%;
						top: -597%;
						bottom: unset;
					}
					.hover-card43 {
						left: 76px;
						bottom: -283px;
						top: unset;
					}
					.hover-card44 {
						left: 301px;
						bottom: -264px;
						top: unset;
					}
					.hover-card45 {
						left: 326px;
						bottom: -301px;
						top: unset;
					}
					.hover-card46 {
						left: 339px;
						bottom: -301px;
						top: unset;
					}
					.hover-card47 {
						left: 618%;
						top: -157px;
						bottom: unset;
					}
					.hover-card54 {
						left: 307px;
						top: -84px;
						bottom: unset;
					}
					.hover-card55 {
						left: 527%;
						top: -283px;
						bottom: unset;
					}
					.hover-card56 {
						left: 542%;
						top: -114px;
						bottom: unset;
					}
					.hover-card57 {
						left: 386%;
						top: -157px;
						bottom: unset;
					}
					.hover-card58 {
						left: 474px;
						bottom: -121px;
						top: unset;
					}
					.hover-card59 {
						left: 262px;
						bottom: 33px;
						top: unset;
					}
					.hover-card60 {
						left: 282px;
						bottom: -112px;
						top: unset;
					}
				}
			}
		}
	}
}

@keyframes fade-in-out {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
